export const NAME_ACTION = ["Добавление", "Изменение", "Удаление", "Включение", "Отключение", "Рестарт"];
export const VK_OPERATOR_TOKEN_COOKIE_KEY = "vk-operator-token"
// Платформа сервера: id_media_core 1 - NimbleStreamer (ВК 2.0), 2 - MediaMTX (ВК 3.0).
export const MEDIA_CORE = { VK2: 1, VK3: 2 };
export const MEDIA_CORE_NAME = { 1: "Nimble", 2: "MediaMTX" };
export const MEDIA_CORE_CLASS = { 1: "media_core_nimble", 2: "media_core_mediamtx" };
